module.exports = __webpack_public_path__ + "static/media/rsmfilter.f31feb02.svg";